















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class CustomizeView extends Vue {
  public items: Common.Customize[] = new Array(0);
  public params: Common.CustomizeQuery = new Common.CustomizeQuery();
  public exportQuery = new Common.ExportQuery('カスタマイズ一覧', this.params);  
  public sortOptions: any =   [{ value: 'id', text: 'ID' }];
  @Prop() public id:number;

  public created(){
  }
  public async onCreate(obj: Common.Customize) {
    const workflows = this.$api.formatter.getOptions('workflow_Customize');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj); 
  }

  public onChangeReleaseDate(item: Common.Customize){
    if(item.releaseDate == null){
      item.maintenanceStartMonth = null;
    }else{
      let result = new Date(item.releaseDate.getFullYear(),item.releaseDate.getMonth(),1);
      result.setMonth(result.getMonth() + 1);
      item.maintenanceStartMonth = result;
    }
  }
  public onChangeDevelopAmount(item: Common.Customize){
    // 開発費用×0.008
    item.maintenanceAmount = Math.floor((item.developAmount * 0.008) / 100) * 100;
  }
}
